// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Play = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <polygon
        xmlns="http://www.w3.org/2000/svg"
        points="1.5 1.9 46.5 24 1.5 46.5 1.5 1.9"
      />
    </svg>
  );
};
